@if ({ menuItems: items$ | async }; as vm) {
  <nav id="app-navbar" class="d-flex flex-nowrap">
    <!-- Logo -->
    <div role="button" class="app-logo d-flex align-items-center cursor-pointer me-4" (click)="onClearLogoClick()">
      <img class="d-none d-sm-inline-block" src="../../assets/clear_logo.png" alt="Clear 2.0" />
      <img class="d-sm-none" src="../../assets/clear_logo_mobile.png" alt="Clear 2.0" />
      <cmg-clear2-ui-version-number class="d-none d-lg-block" />
    </div>
    @if (showTopHeaderUtilities) {
      <div class="align-items-center d-none d-lg-flex">
        <!-- Desktop Menu Bar -->
        <p-menubar [model]="vm.menuItems" class="navbar-main-menu" styleClass="p-0" />
      </div>
    }
    <!-- Leads / Loans Search -->
    @if (showTopHeaderUtilities) {
      <form class="navbar-search d-flex align-items-center justify-content-end flex-grow-1 mx-2" role="search" [formGroup]="searchForm">
        <p-autoComplete
          #autocomplete
          class="p-autocomplete-search p-autocomplete-panel-left flex-full-width flex-grow-1 transparent-placeholder"
          formControlName="searchTerm"
          [emptyMessage]="'No matches found'"
          [group]="true"
          [minLength]="3"
          [showClear]="true"
          [placeholder]="'Search all by Loan #, Address, Name or Email'"
          [scrollHeight]="'500px'"
          [showEmptyMessage]="showEmptyMessage"
          [suggestions]="searchResults"
          [panelStyleClass]="autoCompleteStyleClass"
          pTooltip="{{ searchBarTooltip }}"
          tooltipPosition="left"
          appendTo="body"
          (onFocus)="onFocusGlobalSearch()"
        >
          <ng-template let-group #group>
            @if (!showAllClicked && searchResults && searchResults.length > 0) {
              <div class="search-results-container">
                <div class="search-result-static fw-bold">
                  {{ group.groupName }}
                  @if (!searchFailed) {
                    @if (group.groupName === 'Loans') {
                      <div class="ms-2 total-counts">
                        Showing {{ group?.results?.length }} of {{ group?.totalCount | number: '1.0' : 'en-US' }}<span class="ms-1">Results</span>
                      </div>
                    }
                    @if (group.groupName === 'Loans' && group?.totalCount > maxSearchResultsPerType) {
                      <button class="show-all-btn ms-3" pButton (click)="onClickShowAllLoans(searchTerm, autocomplete)">Show All</button>
                    }
                  }
                  @if (searchFailed) {
                    <span class="search-failed ms-3">Search Failed</span>
                    @if (group?.results?.length === 0) {
                      <button class="retry-search-btn ms-3" pButton (click)="retrySearch()">Try Again</button>
                    }
                    @if (group?.totalCount > maxSearchResultsPerType) {
                      <button class="show-all-btn ms-3" pButton (click)="onClickShowAllLoans(searchTerm, autocomplete)">Show All</button>
                    }
                  }
                </div>
                @if (group?.results?.length > 0) {
                  @for (result of group.results; track result) {
                    <div class="search-result-option" (click)="goToLoan(result)">
                      <div class="d-flex justify-content-between">
                        <div>
                          <div cmgHighlight [searchTerm]="searchTerm" [text]="result.borrowerFirstName + ' ' + result.borrowerLastName"></div>
                          @if (result.type === 'Loan' && result.otherBorrowerFullNames?.length > 0) {
                            @for (otherBorrower of result.otherBorrowerFullNames; track otherBorrower) {
                              <div cmgHighlight [searchTerm]="searchTerm" [text]="otherBorrower"></div>
                            }
                          }
                          <div class="search-result-option-fs-sm">
                            <span cmgHighlight [searchTerm]="searchTerm" [text]="(result.loanNumber || result.leadNumber) ?? ''"></span>
                          </div>
                        </div>
                        <div>
                          <div
                            class="text-end"
                            cmgHighlight
                            [searchTerm]="searchTerm"
                            [text]="result.propertyStreet ? result.propertyStreet : group.groupName === 'Loans' ? 'TBD' : 'No Address'"
                          ></div>
                          <div
                            class="text-end"
                            cmgHighlight
                            [searchTerm]="searchTerm"
                            [text]="
                              result.propertyCity
                                ? result.propertyCity + (result.propertyState ? ', ' + result.propertyState : '')
                                : result.propertyState
                                  ? result.propertyState
                                  : ''
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          </ng-template>
          <ng-template #header>
            @if (!searchFailed && searchRetried && showEmptyMessage) {
              <div class="header-empty-search-message">No matches found</div>
            }
          </ng-template>
        </p-autoComplete>
      </form>
    }
    @if (showTopHeaderUtilities) {
      <div class="d-flex align-items-center">
        <div class="d-flex flex-fill justify-content-end me-2">
          <!-- LibreChat Agents -->
          @if ({ menuItems: libreChatMenuItems$ | async }; as vm) {
            @if (vm.menuItems && vm.menuItems.length > 0) {
              @if ({ enabled: aiDashboardButtonIntegrationEnabled$ | async, link: aiDashboardButtonLink$ | async }; as aiDashboardVm) {
                @if (aiDashboardVm.enabled) {
                  <button
                    #aiDashboardBtn
                    (click)="aiDashboardMenu.toggle($event)"
                    class="clarity-button cursor-pointer me-lg-2 p-2"
                    pTooltip="AI Dashboard"
                    tooltipPosition="bottom"
                  >
                    <img src="/assets/icons/ai-agent-icon-34x34.png" alt="AI Dashboard" />
                  </button>
                  <p-menu #aiDashboardMenu [popup]="true" [model]="aiDashboardMenuItems$ | async" appendTo="body" styleClass="ai-assistants-menu" />
                } @else {
                  <button
                    #libreChatBtn
                    (click)="libreChatMenu.toggle($event)"
                    class="clarity-button cursor-pointer me-lg-2"
                    pTooltip="AI Assistants"
                    tooltipPosition="bottom"
                  >
                    <img src="/assets/icons/ai-agent-icon-34x34.png" alt="AI Assistants" />
                  </button>
                  <p-menu #libreChatMenu [popup]="true" [model]="vm.menuItems" appendTo="body" styleClass="ai-assistants-menu" />
                }
              }
            }
          }
          <!-- Branch -->
          @if (activeProfile$ | async; as activeProfile) {
            <div class="user-branch-lbl d-none d-lg-block">
              <label [pTooltip]="activeProfile?.organizationName" tooltipPosition="left">
                {{ activeProfile?.securityProfileName }}
              </label>
            </div>
          }
        </div>
        <div class="w-100 d-flex align-items-center">
          <!-- Profile -->
          <div>
            <button
              pButton
              pRipple
              type="button"
              (click)="menu.toggle($event)"
              class="user-profile-btn"
              [label]="currentUserInitials$ | async"
            ></button>
            <p-menu #menu [popup]="true" [model]="userProfileMenu$ | async" styleClass="user-profile-menu" />
          </div>
        </div>
      </div>
    }
    <!-- Mobile Sidebar Button -->
    <div class="d-lg-none ms-2 d-flex align-items-center">
      <p-button class="mobile-menu-icon" (click)="isSidebarVisible = !isSidebarVisible" icon="pi pi-bars" />
    </div>
  </nav>
  <p-confirmDialog rejectButtonStyleClass="p-button-secondary" icon="pi pi-exclamation-triangle" />
  <p-drawer
    [(visible)]="isSidebarVisible"
    [baseZIndex]="10000"
    [modal]="true"
    [dismissible]="true"
    [closeOnEscape]="true"
    position="right"
    styleClass="sidebar-scrollbar primary-bg"
    appendTo="body"
  >
    <ng-container *ngTemplateOutlet="listGroup; context: { $implicit: vm.menuItems }" />
    <ng-container *ngTemplateOutlet="listGroup; context: { $implicit: extraNavItems() }" />
  </p-drawer>
}

<ng-template #listGroup let-navItems>
  @if (navItems) {
    <div class="list-group">
      @for (item of navItems; track item) {
        @if (!!item.items) {
          <div>
            <a class="button-link" (click)="item.toggleMenu = !item.toggleMenu">
              {{ item.label }}
              <i class="fa-solid submenu-icon" [class.fa-angle-up]="item.toggleMenu" [class.fa-angle-right]="!item.toggleMenu"></i>
            </a>
            @for (subItem of item.items; track subItem) {
              <ng-container *ngTemplateOutlet="sidebarLink; context: { $implicit: subItem, isSubmenu: true, isHidden: !item.toggleMenu }" />
            }
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="sidebarLink; context: { $implicit: item, isSubmenu: false, isHidden: item.visible === false }" />
        }
      }
    </div>
  }
</ng-template>

<ng-template #sidebarLink let-item let-isSubmenu="isSubmenu" let-isHidden="isHidden">
  <div class="link-wrapper" [ngClass]="{ disabled: item.disabled, 'd-none': isHidden }" [pTooltip]="item.tooltip">
    @if (item.command) {
      <a
        class="button-link"
        [class.submenu]="isSubmenu"
        [ngClass]="{ disabled: item.disabled }"
        (click)="item.command($event); isSidebarVisible = false"
      >
        {{ item.label }}
      </a>
    }
    @if (item.routerLink) {
      <a
        class="button-link"
        [class.submenu]="isSubmenu"
        routerLinkActive="active"
        [ngClass]="{ disabled: item.disabled }"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="item.routerLink"
        [relativeTo]="item.state?.route ?? undefined"
        (click)="isSidebarVisible = false"
      >
        {{ item.label }}
      </a>
    }
    @if (item.url) {
      <a
        class="button-link"
        [class.submenu]="isSubmenu"
        [ngClass]="{ disabled: item.disabled }"
        [href]="item.url"
        [target]="item.target"
        (click)="closeSidebar()"
      >
        {{ item.label }}
      </a>
    }
  </div>
</ng-template>
